export default "<ion-content class=\"bg-popover-content\">\n  <p class=\"popover-content\">\n    {{data}}\n  </p>\n\n</ion-content>";